import { render, staticRenderFns } from "./PainelComentarios.vue?vue&type=template&id=6ce268c3"
import script from "./PainelComentarios.vue?vue&type=script&lang=js"
export * from "./PainelComentarios.vue?vue&type=script&lang=js"
import style0 from "./PainelComentarios.vue?vue&type=style&index=0&id=6ce268c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports